// @flow

import React from 'react';
import { connect } from 'react-redux';
import { withTheme } from 'styled-components';
import withErrorBoundary from '../withErrorBoundary';
import { getGoogleSiteVerification, getGtmCode } from '../../store/siteSettings';
import { getYoast } from '../../store/routes';
import {
  getSiteName,
  getLanguage,
} from '../../store/wpSettings';
import type { Yoast } from '../../types/apiRoute';
import Meta from './meta';
import type { Theme } from '../../types';

type StateProps = {|
  gtmId: ?string,
  googleSiteVerification: string,
  siteName: string,
  language: string,
  yoast: ?Yoast,
|};

type OwnProps = {|
  theme: any,
|};

type Props = {|
  ...StateProps,
  ...OwnProps,
|};
const MetaContainer = ({
  gtmId,
  googleSiteVerification,
  siteName,
  language,
  yoast,
  theme,
}: Props) => {
  const { themeColor } = (theme: Theme).meta;
  return (
    <Meta
      // cookiesAccepted={false} // TODO
      gtmId={gtmId}
      googleSiteVerification={googleSiteVerification}
      siteName={siteName}
      language={language}
      themeColor={themeColor}
      yoast={yoast}
    />
  );
};

const mapStateToProps = (state): StateProps => ({
  // cookiesAccepted: cookiesAccepted(state),
  yoast: getYoast(state),
  gtmId: getGtmCode(state),
  googleSiteVerification: getGoogleSiteVerification(state),
  siteName: getSiteName(state),
  language: getLanguage(state),
});

export default withTheme(
  withErrorBoundary<any, OwnProps, StateProps, any, any, any>(
    connect(
      mapStateToProps,
    )(MetaContainer),
  ),
);
